export const RequestState = {
  NotPerformed: 'NotPerformed',
  Loading: 'Loading',
  Success: 'Success',
  Failed: 'Failed'
}



// WEBPACK FOOTER //
// ./src/requestState.js